import { useState } from 'react';
import { Outlet, useLocation } from 'react-router';

import { BrandMark } from './BrandMark';
import { ShellThemeContext, ShellWidthContext } from './shellWidth';
import { useAccountSession } from '../features/account/session';

/**
 * Areas that carry their own identity bar and use the wide workspace shell, so the guest chrome —
 * the narrow column, the brand header and the footer — steps aside for them.
 *
 * `/manage` is one of them: it used to have a sidebar layout of its own, and now shares the
 * workspace shell and header with `/coach` so that moving between the two does not change what the
 * page is or where its controls are.
 */
const WORKSPACE_PREFIXES = ['/coach', '/home', '/manage'] as const;

export function isWorkspaceRoute(pathname: string): boolean {
  return WORKSPACE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function AppLayout() {
  useAccountSession();
  const { pathname } = useLocation();
  const workspace = isWorkspaceRoute(pathname);
  const [wide, setWide] = useState(false);
  const [booking, setBooking] = useState(false);
  return (
    <div
      className={`app-shell${
        workspace
          ? ' app-shell--workspace'
          : `${wide ? ' app-shell--wide' : ''}${booking ? ' app-shell--booking' : ''}`
      }`}
    >
      {!workspace && (
        <header className="app-header">
          <BrandMark />
        </header>
      )}
      <main className="app-main">
        <ShellWidthContext.Provider value={setWide}>
          <ShellThemeContext.Provider value={setBooking}>
            <Outlet />
          </ShellThemeContext.Provider>
        </ShellWidthContext.Provider>
      </main>
      {!workspace && (
        <footer className="app-footer">
          <span>
            Powered by <strong>PlayerUp</strong> · ⚡️ for your Player Development
          </span>
        </footer>
      )}
    </div>
  );
}
